import React from 'react';
import '../../styles/badges.css';

const STATUS_MAP = {
  'Active':      'ba',
  'Stored':      'bs',
  'Maintenance': 'bm',
  'On repair':   'br',
  'On Lease':    'ba',
};

const LEASE_MAP = {
  'Active lease': 'ba',
  'Available':    'bs',
};

export function StatusBadge({ status }) {
  const cls = STATUS_MAP[status] || 'bs';
  const label = status === 'On Lease' ? 'Active' : status;
  return <span className={`badge ${cls}`}>{label || '—'}</span>;
}

export function LeaseBadge({ status }) {
  const cls = LEASE_MAP[status] || 'bm';
  return <span className={`badge ${cls}`}>{status || '—'}</span>;
}

export function MROTypeBadge({ type }) {
  const map = {
    'C-Check':     'bline',
    'D-Check':     'bbase',
    'Engine Shop': 'bmod',
    'Line Maint':  'bnorm',
    'Repaint':     'bferry',
    'Storage':     'br',
    'Base':        'bbase',
    'Line + A':    'bline',
    'Paint':       'bpaint',
    'Other':       'bm',
  };
  return <span className={`badge ${map[type] || 'bm'}`}>{type}</span>;
}

export function RoleBadge({ role }) {
  const map = { PAX: 'bpax', Cargo: 'bcargo', VIP: 'bvip' };
  return <span className={`badge ${map[role] || 'bm'}`}>{role}</span>;
}

export function FlightTypeBadge({ intl }) {
  return intl
    ? <span className="badge bline">Intl</span>
    : <span className="badge ba">Dom</span>;
}

export function StabilityBadge({ avgHrs }) {
  if (avgHrs >= 8) return <span className="badge bnorm">High</span>;
  if (avgHrs >= 5) return <span className="badge bmod">Medium</span>;
  return <span className="badge bunst">Low</span>;
}

export default function Badge({ children, variant = 'bm' }) {
  return <span className={`badge ${variant}`}>{children}</span>;
}
